import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { SEO } from '../components/SEO';
export function KontakPage() {
  return <>
      <SEO title="Hubungi Kami - PT Wahana Konstruksi Mandiri | Kontak & Lokasi" description="Hubungi PT WKM untuk konsultasi konstruksi. Kantor Pusat: Tanah Bumbu, Kalsel. Kantor Cabang: Samarinda, Kaltim. Telp: (021) 5553 1569. Email: info@wkmkonstruksi.id" keywords="kontak WKM, alamat kantor, telepon WKM, email WKM, lokasi kantor, Tanah Bumbu, Samarinda, hubungi kontraktor" data-id="element-378" />

      <div className="py-12 bg-wkm-slate-50 min-h-screen" data-id="element-379">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-380">
          <div className="text-center mb-16" data-id="element-381">
            <div className="inline-block px-3 py-1 bg-wkm-gold-100 text-wkm-gold-700 rounded-full text-xs font-semibold uppercase tracking-wide mb-4" data-id="element-382">
              Contact Us
            </div>
            <h1 className="text-4xl font-bold text-wkm-navy-900 mb-4" data-id="element-383">
              Hubungi Kami
            </h1>
            <p className="text-lg text-wkm-slate-600 max-w-2xl mx-auto" data-id="element-384">
              Kami siap membantu kebutuhan konstruksi Anda. Silakan hubungi kami
              melalui informasi kontak di bawah ini.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-5xl mx-auto mb-12" data-id="element-385">
            <Card className="hover:border-wkm-gold-300 hover:shadow-lg transition-all duration-300" data-id="element-386">
              <div className="flex items-start mb-6" data-id="element-387">
                <div className="w-12 h-12 bg-wkm-gold-100 text-wkm-gold-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-388">
                  <MapPin className="w-6 h-6" data-id="element-389" />
                </div>
                <div data-id="element-390">
                  <h3 className="text-xl font-bold text-wkm-navy-900 mb-2" data-id="element-391">
                    Kantor Pusat (Head Office)
                  </h3>
                  <p className="text-sm text-wkm-slate-500 uppercase tracking-wide font-medium" data-id="element-392">
                    Tanah Bumbu, Kalimantan Selatan
                  </p>
                </div>
              </div>

              <div className="space-y-4" data-id="element-393">
                <div className="flex items-start" data-id="element-394">
                  <MapPin className="w-5 h-5 text-wkm-gold-500 mr-3 mt-1 flex-shrink-0" data-id="element-395" />
                  <p className="text-wkm-slate-600" data-id="element-396">
                    Jl. Kodeco KM 2 Ruko Jhonlin Indah Blok B No. 09, Desa/Kel.
                    Sari Gadung, Kec. Simpang Empat, Kab. Tanah Bumbu,
                    Kalimantan Selatan 72213
                  </p>
                </div>
                <div className="flex items-center" data-id="element-397">
                  <Phone className="w-5 h-5 text-wkm-gold-500 mr-3 flex-shrink-0" data-id="element-398" />
                  <a href="tel:02155531569" className="text-wkm-slate-600 hover:text-wkm-gold-600 transition-colors" data-id="element-399">
                    (021) 5553 1569
                  </a>
                </div>
                <div className="flex items-center" data-id="element-400">
                  <Mail className="w-5 h-5 text-wkm-gold-500 mr-3 flex-shrink-0" data-id="element-401" />
                  <a href="mailto:info@wkmkonstruksi.id" className="text-wkm-slate-600 hover:text-wkm-gold-600 transition-colors" data-id="element-402">
                    info@wkmkonstruksi.id
                  </a>
                </div>
              </div>
            </Card>

            <Card className="hover:border-wkm-gold-300 hover:shadow-lg transition-all duration-300" data-id="element-403">
              <div className="flex items-start mb-6" data-id="element-404">
                <div className="w-12 h-12 bg-wkm-gold-100 text-wkm-gold-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-405">
                  <MapPin className="w-6 h-6" data-id="element-406" />
                </div>
                <div data-id="element-407">
                  <h3 className="text-xl font-bold text-wkm-navy-900 mb-2" data-id="element-408">
                    Kantor Cabang (Branch Office)
                  </h3>
                  <p className="text-sm text-wkm-slate-500 uppercase tracking-wide font-medium" data-id="element-409">
                    Samarinda, Kalimantan Timur
                  </p>
                </div>
              </div>

              <div className="space-y-4" data-id="element-410">
                <div className="flex items-start" data-id="element-411">
                  <MapPin className="w-5 h-5 text-wkm-gold-500 mr-3 mt-1 flex-shrink-0" data-id="element-412" />
                  <p className="text-wkm-slate-600" data-id="element-413">
                    Jl. Mangkupalas Business Center, Desa/Kel. Simpang Pasir,
                    Kec. Palaran, Kota Samarinda, Kalimantan Timur 75251
                  </p>
                </div>
              </div>
            </Card>
          </div>

          <div className="max-w-5xl mx-auto mb-12" data-id="element-414">
            <Card className="bg-gradient-to-br from-wkm-navy-900 to-wkm-navy-800 border-wkm-gold-500/30 text-white" data-id="element-415">
              <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-416">
                <div className="flex-1" data-id="element-417">
                  <div className="inline-flex items-center px-3 py-1 rounded-full bg-wkm-gold-500/20 border border-wkm-gold-500/30 text-wkm-gold-300 text-xs font-bold uppercase tracking-wide mb-4" data-id="element-418">
                    Official Contact
                  </div>
                  <h3 className="text-2xl font-bold mb-3" data-id="element-419">
                    Corporate Secretary
                  </h3>
                  <p className="text-wkm-slate-300 mb-6" data-id="element-420">
                    Untuk kebutuhan korespondensi resmi, investor relations,
                    keterbukaan informasi, dan komunikasi dengan regulator
                    (OJK/BEI).
                  </p>
                  <div className="flex items-center" data-id="element-421">
                    <Mail className="w-5 h-5 text-wkm-gold-400 mr-3" data-id="element-422" />
                    <a href="mailto:corsec@wkmkonstruksi.id" className="text-wkm-gold-400 hover:text-wkm-gold-300 transition-colors font-semibold text-lg" data-id="element-423">
                      corsec@wkmkonstruksi.id
                    </a>
                  </div>
                </div>
                <div className="flex-shrink-0" data-id="element-424">
                  <div className="w-32 h-32 bg-wkm-gold-500/10 rounded-full flex items-center justify-center border-2 border-wkm-gold-500/30" data-id="element-425">
                    <Mail className="w-16 h-16 text-wkm-gold-400" data-id="element-426" />
                  </div>
                </div>
              </div>
            </Card>
          </div>

          <div className="max-w-5xl mx-auto" data-id="element-427">
            <div className="bg-white rounded-xl border border-wkm-slate-200 p-8 text-center" data-id="element-428">
              <Clock className="w-12 h-12 text-wkm-gold-500 mx-auto mb-4" data-id="element-429" />
              <h3 className="text-xl font-bold text-wkm-navy-900 mb-2" data-id="element-430">
                Jam Operasional
              </h3>
              <p className="text-wkm-slate-600 mb-4" data-id="element-431">
                Senin - Jumat: 08:00 - 17:00 WIB
              </p>
              <p className="text-sm text-wkm-slate-500" data-id="element-432">
                Sabtu, Minggu & Hari Libur Nasional: Tutup
              </p>
            </div>
          </div>
        </div>
      </div>
    </>;
}